import styled from "styled-components";

export const HeroSection = styled.section`
  padding: 32px 80px 80px;
  background-image: url('/AugustBackground.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(16, 16, 21, 0.50);
    z-index: 0;
  }

  @media (max-width: 768px) {
    height: 60%;
    padding: 200px 24px 70px;
    background-size: cover; /* or try 'auto 100%' or '100% auto' */
    background-position: center center;
    /* Add image rendering for better quality */
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
`;

export const HeroContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
  padding-top: 40px;
  position: relative;
  z-index: 1;
  min-height: 80dvh;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
    padding-top: 24px;
    min-height: auto;
  }
`;

export const EyebrowText = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 12px;
`;

export const HeroText = styled.div`
  width: 90%;
  margin-top: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    font-size: 82px;
    margin-bottom: 16px;
    color: #fff;
    font-family: 'Playfair Display', serif;
    font-weight: 500;
    line-height: 1.2;
    
    @media (max-width: 768px) {
      font-size: 36px;
    }
  }

  p {
    font-size: 22px;
    line-height: 30px;
    margin-bottom: 24px;
    color: #FAFAFA;
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    border: none;
    background: #1A1A1A;
    color: #FFF;
    cursor: pointer;
    font-size: 18px;
    font-weight: 500;
    border-radius: 999px;
    transition: transform 0.3s ease, background 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      background: #f5f5f5;
      color: #000;
      
      .arrow-container {
        background: #000;
        color: #fff;
      }
    }

    .arrow-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: #FFF;
      color: #000;
      border-radius: 50%;
      transition: all 0.3s ease;
    }
  }
`;